import {createSelector} from 'reselect';
import _ from 'lodash';

// const getVisibilityFilter = (state) => state.visibilityFilter
// const getTodos = (state) => state.todos
//
// export const getVisibleTodos = createSelector(
//     [ getVisibilityFilter, getTodos ],
//     (visibilityFilter, todos) => {
//         switch (visibilityFilter) {
//             case 'SHOW_ALL':
//                 return todos
//             case 'SHOW_COMPLETED':
//                 return todos.filter(t => t.completed)
//             case 'SHOW_ACTIVE':
//                 return todos.filter(t => !t.completed)
//         }
//     }
// )

const getRoom = (state) => state.room.data;
const getCurrentUserId = (state) => _.get(state.currentUser.data, "_id");

const hydrateRoom = (room, currentUserId) => {
    let users = Array.isArray(room.users) ? room.users : [];
    let usersManagement = Array.isArray(room.usersManagement) ? room.usersManagement : [];
    room.participantsWithoutCurrent = users.filter(user => user._id !== currentUserId);
    room.currentUserIsOwner = _.get(room,"owner._id") === currentUserId;
    room.isLocked = !!usersManagement.find(user => user.locked);
    room.currentUserIsLocker = !!usersManagement.find(user => (user.locked && user.owner === currentUserId));
    room.currentUserIsArchived = !!usersManagement.find(user => (user.archived && user.owner === currentUserId));
    room.hasUserOnline = !room.isLocked && !!users.find(user => (user.online && user._id !== currentUserId));
    room.isReadByCurrentUser = !!_.get(usersManagement.find(user => user.owner === currentUserId), 'read');
    room.currentUserId = currentUserId
    return room;
};

export const getRoomEnhanced = createSelector(
    [getRoom, getCurrentUserId],
    (room, currentUserId) => {
        return room._id ? hydrateRoom(room, currentUserId) : {};
    }
)